import {useDefault} from '../../common/common';
import {ReservationChangeType} from '../../api/model/reservation/change/reservation-change.model';
import {Stay} from '../../api/model/reservation/stay.model';
import {IAppState} from '../interfaces/IAppState';
import {DateUtils} from '../../common/date.utils';
import {Rate} from '../../api/model/reservation/rate/rate.model';
import {Room} from '../../api/model/reservation/room/room.model';
import {Reservation} from '../../api/model/reservation/reservation.model';

export class ReservationChangeUtils {
  /**
   * Merge the change in a changes map only when it is actually a change in the Reservation, if as a result of the new value there is not change in the reservation, it deletes the change from the changes map
   * @param currentReservation
   * @param currentChanges
   * @param changeType the change type
   * @param newValue the new value
   * @returns {Map<ReservationChangeType, any>} a new Map with the merged changes
   */
  static mergeChange(currentReservation: Reservation, currentChanges: Map<ReservationChangeType, any> , changeType: ReservationChangeType, newValue: any): Map<ReservationChangeType, any> {
    const newChanges: Map<ReservationChangeType, any> = new Map<ReservationChangeType, any>(currentChanges.entries());
    const reservation: Reservation = useDefault(currentReservation, new Reservation());
    const stay: Stay = useDefault(reservation.stay, new Stay());
    const rate: Rate = useDefault(reservation.rate, new Rate());
    const room: Room = useDefault(reservation.room, new Room());
    switch (changeType) {
      case ReservationChangeType.CHECK_IN_DATE:
        ReservationChangeUtils._mergeIf(newChanges, changeType, stay.checkInDate, newValue, (p1: any, p2: any) => DateUtils.toShortISODate(p1) === DateUtils.toShortISODate(p2));
        break;
      case ReservationChangeType.CHECK_OUT_DATE:
        ReservationChangeUtils._mergeIf(newChanges, changeType, stay.checkOutDate, newValue, (p1: any, p2: any) => DateUtils.toShortISODate(p1) === DateUtils.toShortISODate(p2));
        break;
      case ReservationChangeType.NUMBER_OF_ADULTS:
        ReservationChangeUtils._mergeIf(newChanges, changeType, stay.numberOfAdults, newValue, (p1: any, p2: any) => p1 === p2);
        break;
      case ReservationChangeType.NUMBER_OF_CHILDREN:
        ReservationChangeUtils._mergeIf(newChanges, changeType, stay.numberOfChildren, newValue, (p1: any, p2: any) => p1 === p2);
        break;
      case ReservationChangeType.NUMBER_OF_ROOMS:
        ReservationChangeUtils._mergeIf(newChanges, changeType, stay.numberOfRooms, newValue, (p1: any, p2: any) => p1 === p2);
        break;
      case ReservationChangeType.RATE:
        ReservationChangeUtils._mergeIf(newChanges, changeType, rate.code, newValue, (p1: any, p2: any) => p1 === p2);
        break;
      case ReservationChangeType.ROOM:
        ReservationChangeUtils._mergeIf(newChanges, changeType, room.code, newValue, (p1: any, p2: any) => p1 === p2);
        break
      case ReservationChangeType.GROUP_CODE:
        ReservationChangeUtils._mergeIf(newChanges, changeType, rate.groupCode, newValue, (p1: any, p2: any) => p1 === p2);
        break;
    }
    return newChanges;
  }

  private static _mergeIf(map: Map<ReservationChangeType, any>, changeType: ReservationChangeType, oldValue: any, newValue: any, equalsBiPredicate: (currentValue: any, newValue: any) => boolean) {
    if (!equalsBiPredicate(oldValue, newValue)) {
      map.set(changeType, newValue);
    } else {
      map.delete(changeType);
    }
  }
}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/store/util/reservation-changes.util.ts